import CollectionList from "./CollectionList";

export default CollectionList